import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { userState } from "../../states/userState";
import { useNavigate } from "react-router-dom";
import { Header } from "../header/Header";
import classes from "./Main.module.scss";
import { Footer } from "../footer/Footer";
import HeaderController from "../uikit/HeaderController";
import TableArea from "../uikit/TableArea";
import ScrollButton from "../uikit/atoms/ScrollButton";
import { backgroundColor, backgroundColorDrafts } from "../../commons/colors";
const Main = () => {
  const user = useRecoilValue(userState);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user.isAuth) {
      navigate("/login");
    }
  }, []);
  return (
    <div>
      <Header pageTitle={"図面検索"} />
      <div
        className={classes.login}
        style={backgroundColorDrafts(user?.mode ?? "lite")}
      >
        <div className={classes.loginWrapper}>
          <TableArea />
          <ScrollButton />
        </div>
      </div>
    </div>
  );
};

export default Main;
